/**
 *Created by jmmartinez on 03/05/19
 * v 1.1 27/06/2019 Fijado tamaño del cuadro de color.
 * v 1.2 28/05/2020 Mejorado aspecto
 * v.2.0  30/09/2020 Cambiado a framework2
 **/

import React from 'react'
import PropTypes from 'prop-types';

import { SketchPicker } from 'react-color';


class ColorPicker extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            color: props.color ? props.color : "#ffffff",
            showColorPicker: false,
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.color !== prevState.color) {
            newState.color = nextProps.color;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    onChange= (color) => {
        const {onChange} = this.props;
        this.setState({color: color.hex});
        onChange && onChange(color.hex);
    }

    render() {

        const {color} = this.state;
        return(
            <div>
                <div style={{margin: 'auto', padding: '5px 0', width: '90%', height: '30px', border: '1px solid', backgroundColor: color}} onClick={ () => this.setState({showColorPicker: true})}>
                    {color ? color : "Seleccione color"}
                </div>
                { this.state.showColorPicker &&
                    <div  onClick={() =>  this.setState({showColorPicker: false}) }>
                        <SketchPicker color={color } onChange={ this.onChange } />
                    </div>
                }

            </div>
        );
    }

}


ColorPicker.propTypes = {
    id: PropTypes.string,
    color: PropTypes.string,

}

export default ColorPicker

